import React from "react";
import { CustomerData } from "./shared/customer-data/types/Types";

// We can gradually update this with the context values used in Typescript components without losing functionality in the Javascript components.
type CheckoutContext = {
  data: {
    countries: { name: string; value: string }[];
    customerData: CustomerData;
  };
  addressEndpointUrl: string;
  cocEndpointUrl: string;
  textsMapping: Record<string, string>;
  serverErrors: string[];
  removeServerErrors: () => void;
};

export default React.createContext<CheckoutContext>({
  data: {
    countries: [],
    customerData: {} as CustomerData,
  },
  addressEndpointUrl: "",
  cocEndpointUrl: "",
  textsMapping: {},
  serverErrors: [],
  removeServerErrors: () => {},
});
